(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sempasi-black-friday-2026"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sbf-menu nav a').forEach(function(link) {
    link.addEventListener('click', function() { link.closest('details').removeAttribute('open'); });
  });

  } catch(e) { console.error(e); }
})();
})();
